export function OutlinePuzzleIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0016 7.50239C14.0016 8.32799 13.3296 8.99999 12.4992 8.99999C12.3264 8.99999 12.1536 8.97119 12 8.91359V12H8.91359C8.97119 11.8464 8.99999 11.6736 8.99999 11.5008C8.99999 10.6704 8.32799 9.99839 7.50239 9.99839C6.67679 9.99839 5.99999 10.6704 5.99999 11.5008C5.99999 11.6736 6.02879 11.8464 6.08639 12H3V4.9968C3 3.8928 3.8928 3 4.9968 3H12V6.08639C12.1536 6.02879 12.3264 5.99999 12.4992 5.99999C13.3296 5.99999 14.0016 6.67199 14.0016 7.50239Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12H17.9136C17.9712 12.1536 18 12.3264 18 12.4992C18 13.3296 17.328 14.0016 16.5024 14.0016C15.6768 14.0016 15 13.3296 15 12.4992C15 12.3264 15.0288 12.1536 15.0864 12H12V8.91359C12.1536 8.97119 12.3264 8.99999 12.4992 8.99999C13.3296 8.99999 14.0016 8.32799 14.0016 7.50239C14.0016 6.67679 13.3296 5.99999 12.4992 5.99999C12.3264 5.99999 12.1536 6.02879 12 6.08639V3H19.0032C20.1072 3 21 3.8928 21 4.9968V12Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12V19.0032C21 20.1072 20.1072 21 19.0032 21H12V17.9136C11.8464 17.9712 11.6784 18 11.5008 18C10.6704 18 10.0032 17.328 10.0032 16.5024C10.0032 15.6768 10.6704 15 11.5008 15C11.6784 15 11.8464 15.0288 12 15.0864V12H15.0864C15.0288 12.1536 15 12.3264 15 12.4992C15 13.3296 15.672 14.0016 16.5024 14.0016C17.3328 14.0016 18 13.3296 18 12.4992C18 12.3264 17.9712 12.1536 17.9136 12H21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0032 16.502C10.0032 17.3276 10.6704 17.9996 11.5008 17.9996C11.6784 17.9996 11.8464 17.9708 12 17.9132V20.9996H4.9968C3.8928 20.9996 3 20.1068 3 19.0028V11.9996H6.08639C6.02879 11.846 5.99999 11.6732 5.99999 11.5004C5.99999 10.67 6.67199 9.99805 7.50239 9.99805C8.33279 9.99805 8.99999 10.67 8.99999 11.5004C8.99999 11.6732 8.97119 11.846 8.91359 11.9996H12V15.086C11.8464 15.0284 11.6784 14.9996 11.5008 14.9996C10.6704 14.9996 10.0032 15.6716 10.0032 16.502Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
